export default [
  {
    path: "index",
    component: () => import("./user-manage/index.vue")
  },
  {
    path: "base-info/user-manage",
    name: "userManage",
    component: () => import("./user-manage/index.vue"),
    meta: {
      code: "/basic/agent.htm"
    }
  },
  {
    path: "base-info/business-company-manage",
    name: "businessCompanyManage",
    component: () => import("./business-company-manage/index.vue"),
    meta: {
      code: "/basic/dispatch.htm"
    }
  },
  {
    path: "base-info/medicine-factory-manage",
    name: "medicine-factory-manage",
    component: () => import("./medicine-factory-manage/index.vue"),
    meta: {
      code: "/basic/factoryInfo.htm"
    }
  },
  {
    path: "base-info/medicine-classify",
    name: "medicine-classify",
    component: () => import("./medicine-classify/index.vue"),
    meta: {
      code: "/basic/basicMedicineType.htm"
    }
  },
  {
    path: "base-info/medicine-manage",
    name: "medicine-manage",
    component: () => import("./medicine-manage/index.vue"),
    meta: {
      code: "/basic/drugInfo.htm"
    }
  },
  {
    path: "base-info/medicine-type-manage",
    name: "medicine-type-manage",
    component: () => import("./medicine-type-manage/index.vue"),
    meta: {
      code: "/base/baseDrugType.htm"
    }
  },
  {
    path: "base-info/disease-detail",
    name: "disease-detail",
    component: () => import("./disease-detail/index.vue"),
    meta: {
      code: "BASIC_SICKNESS_INFO_QUERY"
    }
  },
  {
    path: "base-info/disease-type",
    name: "disease-type",
    component: () => import("./disease-type/index.vue"),
    meta: {
      code: "/basic/sicknessType.htm"
    }
  },
  {
    path: "base-info/cooperation-area",
    name: "cooperation-area",
    component: () => import("./cooperation-area/index.vue"),
    meta: {
      code: "/basic/joinArea.htm"
    }
  },
  {
    path: "base-info/platform-hospital-manage",
    name: "platform-hospital-manage",
    component: () => import("./platform-hospital-manage/index.vue"),
    meta: {
      code: "/basic/hospital.htm"
    }
  },
  {
    path: "base-info/index",
    name: "platform-user-manage",
    component: () => import("./platform-user-manage/index.vue"),
    meta: {
      code: "/basic/superAdmin.htm"
    }
  },
  {
    path: "base-info/medical-insurance-menu",
    name: "medical-insurance-menu",
    component: () => import("./medical-insurance-menu/index.vue"),
    meta: {
      code: "/basic/drugMedicareDirectory.htm"
    }
  },
  {
    path: "base-info/medication-instructions",
    name: "medication-instructions",
    component: () => import("./medication-instructions/index.vue"),
    meta: {
      code: "/basic/drugTypeNotes.htm"
    }
  },
  {
    path: "base-info/bidding-price",
    name: "bidding-price",
    component: () => import("./bidding-price/index.vue"),
    meta: {
      code: "/basic/zbj.htm"
    }
  },
  {
    path: "base-info/medication-code",
    name: "medication-code",
    component: () => import("./medication-code/index.vue"),
    meta: {
      code: "/basic/ybbm.htm"
    }
  },
  {
    path: "base-info/low-price-drug-menu",
    name: "low-price-drug-menu",
    component: () => import("./low-price-drug-menu/index.vue"),
    meta: {
      code: "/basic/lowPriceDrugDirectory.htm"
    }
  },
  {
    path: "base-info/zygj-f-menu",
    name: "zygj-f-menu",
    component: () => import("./zygj-f-menu/index.vue"),
    meta: {
      code: "/basic/basicMedicine.htm"
    }
  },
  {
    path: "base-info/zyk-f-menu",
    name: "zyk-f-menu",
    component: () => import("./zyk-f-menu/index.vue"),
    meta: {
      code: "/basic/baseDrugDirectory.htm"
    }
  },
  {
    path: "base-info/evaluate-pass",
    name: "evaluate-pass",
    component: () => import("./evaluate-pass/index.vue"),
    meta: {
      code: "/basic/conformanceAssessmentPass.htm"
    }
  },
  {
    path: "base-info/evaluate-no-pass",
    name: "evaluate-no-pass",
    component: () => import("./evaluate-no-pass/index.vue"),
    meta: {
      code: "/basic/conformanceAssessmentNoPass.htm"
    }
  },
  {
    path: "base-info/agent-user-manage",
    name: "agent-user-manage",
    component: () => import("./agent-user-manage/index.vue"),
    meta: {
      code: "/basic/enterprise.htm"
    }
  },
  {
    path: "base-info/self-agent-user-manage",
    name: "self-agent-user-manage",
    component: () => import("./self-agent-user-manage/index.vue"),
    meta: {
      code: "/basic/spreadInfo.htm"
    }
  },
  {
    path: "base-info/investment-manage",
    name: "investment-manage",
    component: () => import("./investment-manage/index.vue"),
    meta: {
      code: "/basic/drugAttraction.htm"
    }
  },
  {
    path: "base-info/literature",
    name: "literature",
    component: () => import("./literature/index.vue"),
    meta: {
      code: "/basic/baseGuideInfo.htm"
    }
  },
  {
    path: "base-info/literature-enclosure",
    name: "literature-enclosure",
    component: () => import("./literature-enclosure/index.vue"),
    meta: {
      code: "/basic/baseGuideReferInfo.htm"
    }
  },
  {
    path: "base-info/drug-system",
    name: "drug-system",
    component: () => import("./drug-system/index.vue"),
    meta: {
      code: "/basic/baseGuideReferInfo.htm"
    }
  },
  {
    path: "base-info/xiaochengxu",
    name: "xiaochengxu",
    component: () => import("./mini-xiaochengxu/index.vue")
  },
  {
    path: "base-info/hospital-library",
    name: "hospital-library",
    component: () => import("./hospital-library/index.vue")
  },
  {
    path: "base-info/review",
    name: "review",
    component: () => import("./review/index.vue")
  },
  {
    path: "base-info/centralized-purchasing",
    name: "centralized-purchasing",
    component: () => import("./centralized-purchasing/index.vue")
  },
  {
    path: "base-info/centralized-purchasing-bidding",
    name: "centralized-purchasing-bidding",
    component: () => import("./centralized-purchasing-bidding/index.vue")
  }
];



// WEBPACK FOOTER //
// ./src/views/base-info/index.route.js